export default __webpack_public_path__ + "static/media/deposit-coin-bg.cc8aceb6.svg";